import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

export type RewardsVerificationTokenState = Record<string, unknown>;

const createInitialState = (): RewardsVerificationTokenState => ({});

@singleton()
@StoreConfig({ name: "RewardsVerificationTokenStore" })
class RewardsVerificationTokenStore extends BaseStore<RewardsVerificationTokenState> {
    constructor() {
        super(createInitialState());
    }
}

export default RewardsVerificationTokenStore;
